const packageTypes = {
	V2_FETCH: {
		REQUEST: 'PACKAGE_V2_FETCH_REQUEST',
		SUCCESS: 'PACKAGE_V2_FETCH_SUCCESS',
		FAILURE: 'PACKAGE_V2_FETCH_FAILURE',
		CLEAR: 'PACKAGE_V2_FETCH_CLEAR',
	},

	V1_FETCH: {
		REQUEST: 'PACKAGE_V1_FETCH_REQUEST',
		SUCCESS: 'PACKAGE_V1_FETCH_SUCCESS',
		FAILURE: 'PACKAGE_V1_FETCH_FAILURE',
		CLEAR: 'PACKAGE_V1_FETCH_CLEAR',
	},

	UPDATE_STATUS: {
		REQUEST: 'PACKAGE_UPDATE_STATUS_REQUEST',
		SUCCESS: 'PACKAGE_UPDATE_STATUS_SUCCESS',
		FAILURE: 'PACKAGE_UPDATE_STATUS_FAILURE',
		CLEAR: 'PACKAGE_UPDATE_STATUS_CLEAR',
	},

	CREATE: {
		REQUEST: 'PACKAGE_CREATE_REQUEST',
		SUCCESS: 'PACKAGE_CREATE_SUCCESS',
		FAILURE: 'PACKAGE_CREATE_FAILURE',
		CLEAR: 'PACKAGE_CREATE_CLEAR',
	},

	UPDATE: {
		REQUEST: 'PACKAGE_UPDATE_REQUEST',
		SUCCESS: 'PACKAGE_UPDATE_SUCCESS',
		FAILURE: 'PACKAGE_UPDATE_FAILURE',
		CLEAR: 'PACKAGE_UPDATE_CLEAR',
	},
	BEST_SELLING: {
		REQUEST: 'PACKAGE_BEST_SELLING_REQUEST',
		SUCCESS: 'PACKAGE_BEST_SELLING_SUCCESS',
		FAILURE: 'PACKAGE_BEST_SELLING_FAILURE',
		CLEAR: 'PACKAGE_BEST_SELLING_CLEAR',
	},
};

export default packageTypes;
